<div class="data-wrap" fxLayout="column">
    <div class="title" fxLayoutGap="5px" fxLayout="row wrap" fxLayoutAlign="start center">
        <mat-icon>maps_ugc</mat-icon><span i18n>Add comment</span>
        <app-ai-model-selector #modelSelector></app-ai-model-selector>
    </div>

    <mat-form-field class="mb-0" floatLabel="never" appearance="fill" fxFlex="0 0 100%">
        <textarea
            maxlength="5000"
            rows="5"
            i18n-placeholder
            placeholder="Type in your comment"
            #message
            matInput
            [formControl]="comment"
        ></textarea>
    </mat-form-field>
    <mat-checkbox class="mb-1" [formControl]="ai_generated_control" i18n>Generate comment with AI</mat-checkbox>
    <div class="alert-media-attach">
        <app-media-attachment
            #uploader
            [maxImgCount]="10"
            [formControl]="media_ids"
            [scope]="navData.data.scope"
            [mediaIds]="!!media_ids.value?.length ? media_ids.value : []"
            [isCreateForm]="true"
            (onUploadOrRemoveCompleted)="buttonDisabled = false"
            type="file"
        ></app-media-attachment>
        <div fxLayoutAlign="center center" *ngIf="uploader.saving | async">
            <app-kd-logo-loading></app-kd-logo-loading>
        </div>
    </div>
    <div class="action">
        <button
            *ngIf="!(saving | async)"
            [disabled]="!comment.value || buttonDisabled"
            fxFlex="0 0 auto"
            class="mobile-button"
            (click)="submit()"
            mat-raised-button
        >
            <span i18n>Add comment</span>
        </button>
        <ng-container *ngIf="saving | async">
            <app-saving-button></app-saving-button>
        </ng-container>
    </div>
</div>
